import { render, staticRenderFns } from "./ItemGroups.vue?vue&type=template&id=5de80043"
import script from "./ItemGroups.vue?vue&type=script&lang=ts"
export * from "./ItemGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports